import Ground from "@scene/objects/ground";
import { initState as initDimensionState} from "@reducers/selectors/dimension";
import { initState as initMaterialState } from "@reducers/selectors/material";
import { APP_TYPES } from "@config";

export default {
  type: Ground.types.BASE,
  width: 200,
  // VladP: Error after changing from Rebar to SafetyBarrier
  // height: null, // Calculate
  depth: initMaterialState[APP_TYPES.SAFETY_BARRIER].concrete.thicknessOfConcrete,
  padding: {
    C1x: 30, // Null = ∞ char in UI
    C2x: null,
    C1y: 30,
    C2y: null
  },
  stairs: {
    width: initDimensionState[APP_TYPES.SAFETY_BARRIER].stairsDimensions.lst,
    height: initDimensionState[APP_TYPES.SAFETY_BARRIER].stairsDimensions.hst,
    tst: initDimensionState[APP_TYPES.SAFETY_BARRIER].stairsDimensions.tst,
    count: 12
  },
  walls: {
    width: 100,
    height: 500,
    depth: initDimensionState[APP_TYPES.SAFETY_BARRIER].wallDimensions.w,
    spaceBetween: 300,
    '2D': {
      height: 200
    },
    ground: {
      height: 100,
      padding: 300
    }
  },
  pedestal: {
    width: 800,
    '2D': {
      width: 100
    },
    ground: {
      padding: 400,
      depth: initDimensionState[APP_TYPES.SAFETY_BARRIER].pedestalDimensions.h2
    },
    finish: {
      color: 0xDCDCDC,
      height: 100,
      depth: initDimensionState[APP_TYPES.SAFETY_BARRIER].pedestalDimensions.href
    },
    pedestal: {
      height: initDimensionState[APP_TYPES.SAFETY_BARRIER].pedestalDimensions.w,
      depth: initDimensionState[APP_TYPES.SAFETY_BARRIER].pedestalDimensions.h1
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/ground/defaults/safetyBarrier.js